<template>
  <v-card-text>
    <p>
      25 ноября 2024 года заканчивается действие текущего домена <span class="blue--text text--lighten-1">sakura.aero</span> без возможности его продления.
    </p>
    <p>
      В данный момент мы переходим на новый домен <span class="blue--text text--lighten-1">sakura-aero.com</span>.
    </p>
    <p>
      Утром 25 ноября 2024 года окончательно уйдем от использования текущего домена и перейдем на новый.
    </p>
    <p>
      Подробности связанные с переходом на новый домен отправлены на почту.
    </p>
    <p>
      Для работы на новом домене уже сейчас перейдите по <a href="https://02.sakura-aero.com/login" target="_blank" rel="noopener noreferrer">ссылке</a>.
    </p>
  </v-card-text>
</template>

<script>
export default {
  name: 'NoteText'
}
</script>
